var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[_c('h1',[_vm._v("接入中....")]),_c('h1',[_vm._v(_vm._s(_vm.corpId))]),_c('h1',[_vm._v(_vm._s(_vm.consoleMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }